import * as React from "react";
import { ArrowUpRight, Clock, MapPin, Navigation, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function OurOperationsHub() {
  return <section data-section-id="223792" id="dove-trovarci" className="bg-background text-foreground relative w-full min-h-[650px] flex items-center overflow-hidden border-y border-border">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/ibiza_marina_botafoch_map.png)] bg-cover bg-center opacity-40 grayscale contrast-125 mix-blend-luminosity"></div>
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-5"></div>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent w-full md:w-2/3 lg:w-1/2"></div>
      </div>

      {}
      <div className="absolute top-[45%] right-[10%] lg:right-[25%] hidden md:flex flex-col items-center z-10 animate-pulse">
        <div className="relative">
          <MapPin className="size-14 text-secondary drop-shadow-[0_0_15px_rgba(212,175,55,0.6)]" fill="currentColor" />
          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-5 h-1.5 bg-black/40 blur-[2px] rounded-lg"></div>
        </div>
        <div className="mt-3 px-3 py-1.5 bg-secondary/95 backdrop-blur-sm border border-secondary/20 rounded-md text-xs font-mono text-secondary-foreground bg-secondary shadow-lg tracking-wider">
          NAVIS HQ
        </div>
      </div>

      {}
      <div className="container relative z-20 px-4 py-12 md:py-24">
        <Card className="w-full max-w-md bg-card/90 backdrop-blur-md border-border/40 shadow-2xl rounded-md overflow-hidden">
          {}
          <div className="h-1 w-full bg-secondary"></div>
          
          <CardHeader className="pb-6 pt-8">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-md bg-primary/5 text-primary mb-5 border border-primary/10">
              <Navigation className="size-6" />
            </div>
            <CardTitle className="font-default text-3xl font-bold tracking-tighter text-foreground">
              Dove Trovarci
            </CardTitle>
            <CardDescription className="font-default text-base text-muted-foreground mt-2">
              La nostra sede operativa a Marina Botafoch è il punto di riferimento per il brokeraggio nautico d'élite a Ibiza.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="space-y-6 pb-8">
            <div className="flex gap-4 items-start">
              <div className="mt-0.5 bg-muted rounded-md p-2.5 shrink-0 border border-border/30">
                <MapPin className="size-4 text-secondary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground text-sm uppercase tracking-widest mb-1">
                  Ufficio Centrale
                </h4>
                <p className="font-default text-sm text-muted-foreground leading-relaxed">
                  NAVIS Yacht Brokerage<br />
                  Marina Botafoch, Ibiza, Spagna
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="mt-0.5 bg-muted rounded-md p-2.5 shrink-0 border border-border/30">
                <Clock className="size-4 text-secondary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground text-sm uppercase tracking-widest mb-1">
                  Orari di Ricevimento
                </h4>
                <p className="font-default text-sm text-muted-foreground leading-relaxed">
                  Lun - Sab: 09:00 - 19:00<br />
                  Consulenza Elite: 24/7
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="mt-0.5 bg-muted rounded-md p-2.5 shrink-0 border border-border/30">
                <Phone className="size-4 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground text-sm uppercase tracking-widest mb-1">
                  Contatto Diretto
                </h4>
                <p className="font-default text-sm text-muted-foreground leading-relaxed">
                  +34 971 000 000
                </p>
              </div>
            </div>
          </CardContent>
          
          <CardFooter className="pt-0 pb-8">
            <Button asChild className="w-full h-12 text-base font-semibold rounded-md bg-primary text-primary-foreground shadow-md hover:bg-primary/90 hover:shadow-lg transition-all duration-300 border-b-2 border-secondary/50">
              <Link to="https://www.google.com/maps/search/?api=1&query=Marina%20Botafoch%20Ibiza" newTab>
                Ottieni Indicazioni
                <ArrowUpRight className="size-5 ml-2" />
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}